// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-k_hk","advertDetailServiceList__header":"c-k_hl","advertDetailServiceList__list":"c-k_hm"};